export const TRANSITIONING = { value: "TRANSITIONING"};
export const TRANSITIONED = { value: "TRANSITIONED"};
export const FAILURE = { value: "FAILURE"};
export default [TRANSITIONING, TRANSITIONED, FAILURE];


// WEBPACK FOOTER //
// ./src/components/common/enums/clientLifecycleTransitionType.js